import { DateFormat, SemboDate } from '@libs/sembo-dates';
import type { DateOnlyString } from '@libs/trip-planner-interfaces';

export function normalizeDate(date: Date): Date {
  return new SemboDate(date)
    .startOf('day')
    .add({ minutes: date.getTimezoneOffset() * -1 })
    .get();
}

export function normalizeDateOnlyString(date: undefined): undefined;
export function normalizeDateOnlyString(date: Date): DateOnlyString;
export function normalizeDateOnlyString(
  date?: Date
): DateOnlyString | undefined;
export function normalizeDateOnlyString(
  date?: Date
): DateOnlyString | undefined {
  if (date === undefined) {
    return undefined;
  }

  const dateOnlyString = new SemboDate(normalizeDate(date)).format(
    DateFormat.DateReverse
  );

  if (!isValidDateOnly(dateOnlyString)) {
    throw new Error(`Invalid dateOnly string: ${dateOnlyString}`);
  }

  return dateOnlyString;
}

function isValidDateOnly(dateString: string): dateString is DateOnlyString {
  const semboDate = new SemboDate(dateString);

  return (
    semboDate.isValidDate() &&
    semboDate.format(DateFormat.DateReverse) === dateString
  );
}
